import Select from 'react-select';
import { useFormOptions } from '../../../config/constants';
import { formRevisionServicio } from '../../../objetos/objeto_servicio';
import React, { useEffect, useState, useMemo } from 'react';
import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad';
import { toast } from 'react-toastify';
import { formatearFechaCompleta } from '../../../utils/utils';
import ListaChat from '../../../views/chatBasico/listachat';
import { AlertCircle, CheckCircle, MessageSquare, Send } from 'lucide-react';

const ModuloRevision = ({
    servicio,
    isAdmin,
    chatHabilitado = true,
}) => {

  const [formData, setFormData] = useState(formRevisionServicio);
  const {
    conceptoRevision,
    conceptoRevisionOptions,
  } = useFormOptions();
  const {
    updateServicio
  } = useContabilidadModel();
  const { revision } = servicio;
  const [estaEditando, setEstaEditando] = useState(false);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };
  
  const handleSubmit = async(e) => {
    e.preventDefault();
    
    const dataFinal = {
      ...formData,
      activo: true,                      // Se activa la revisión
      inicioRevision: new Date(),        // Fecha y hora actual
      resuelto: false                    // Empieza como no resuelto
    };

    if (!formData.motivo || !formData.concepto.trim()) {
      toast.error('Debes llenar el motivo y concepto para poder registrar la revision');
      return; // Detiene la ejecución si falta alguno
    }

    await updateServicio(servicio.codigo,servicio.nombreEmpresa,'revision',dataFinal,'field');

    setFormData(formRevisionServicio);

  };

  const getOptionFromValue = (options, value) => {
    if (!value || !options || options.length === 0) return null;
    return options.find(option => option.value === value) || null;
  };
  const handleSelectChange = (selectedOption, { name }) => {
      setFormData({
        ...formData,
        [name]: selectedOption ? selectedOption.value : ''
      });

  };

  //HEADER DE REVISION
  const EstadoRevisionServicio = () => {
    const estado = servicio.getEstadoRevision();
    const [estaResolviendo, setEstaResolviendo] = useState(false);
    const [comentario, setComentario] = useState('');

    // Si el caso ya está resuelto, no mostramos el botón de acción
    const mostrarBotonResolver = isAdmin && !revision.resuelto && revision.activo;

    const handleConfirmarResolucion = async() => {
      if (!comentario.trim()) return toast.error("Por favor ingresa un comentario de resolución.");

      // Preparamos el objeto actualizado
      const revisionActualizada = {
        ...revision,
        resuelto: true,
        activo: true, // Opcional: si quieres que deje de estar "activa" al resolverse
        finRevision: new Date(),
        conceptoResolucion: comentario,
      };

      await handleSaveRevision(revisionActualizada);

      setEstaResolviendo(false);
      setComentario("");

    };

    return (
      <div className={`mb-6 border-2 rounded-xl p-4 ${estado.color} shadow-sm transition-all duration-500 ease-in-out`}>
        
        {/* HEADER E INFO LATERAL (Igual que antes) */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="p-2.5 rounded-lg bg-white bg-opacity-60 shadow-sm">
              {estado.id === 'EN_CURSO' && (
                <span className="relative flex h-5 w-5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-5 w-5 bg-orange-500"></span>
                </span>
              )}
              {estado.id === 'RESUELTA' && <CheckCircle className="w-5 h-5 text-green-600" />}
              {estado.id === 'NO_INICIADA' && <AlertCircle className="w-5 h-5 text-gray-400" />}
            </div>
            
            <div>
              <h4 className="font-black text-lg uppercase tracking-tight leading-none">{estado.label}</h4>
              <p className="text-xs opacity-80 leading-tight mt-0.5">{estado.descripcion}</p>
            </div>
          </div>

          {revision.activo && (
            <div className="hidden lg:block text-right border-l border-current border-opacity-20 pl-4">
              <p className="text-[10px] font-black uppercase opacity-60">Motivo</p>
              <p className="text-sm font-bold">{revision.motivo}</p>
            </div>
          )}
        </div>

        {/* CONCEPTO ACTUAL */}
        {revision.activo && revision.concepto && !estaResolviendo && (
          <div className="mt-3 pt-3 border-t border-current border-opacity-10">
            <p className="text-[10px] font-black uppercase opacity-50 mb-1">Detalles técnicos registrados:</p>
            <p className="text-sm italic font-medium leading-snug">"{revision.concepto}"</p>
          </div>
        )}

        {/* SECCIÓN DE FECHAS */}
        {!estaResolviendo && revision.activo && (
          <div className="mt-3 pt-2 border-t border-current border-opacity-10 flex flex-wrap gap-x-5 gap-y-2">
            
            <div className="flex items-center gap-1.5">
              <span className="text-[10px] font-bold uppercase opacity-60">Inicio:</span>
              <span className="text-[11px] font-semibold">{formatearFechaCompleta(revision.inicioRevision)}</span>
            </div>

            {revision.resuelto && (
              <div className="flex items-center gap-1.5 animate-in fade-in">
                <span className="text-[10px] font-bold uppercase text-green-700">Finalizada:</span>
                <span className="text-[11px] font-bold text-green-700">{formatearFechaCompleta(revision.finRevision)}</span>
              </div>
            )}

          

          </div>
        )}

        {revision.conceptoResolucion && (
          <div className="mt-3 pt-3 border-t border-current border-opacity-10">
            <p className="text-[10px] font-black uppercase opacity-50 mb-1">Resolucion:</p>
            <p className="text-sm italic font-medium leading-snug">"{revision.conceptoResolucion}"</p>
          </div>
        )}

        {/* --- NUEVA SECCIÓN DE ADMINISTRADOR: RESOLUCIÓN --- */}
        {isAdmin && (
          <div className="mt-4 pt-4 border-t-2 border-current border-opacity-10">
            {!estaResolviendo ? (
              mostrarBotonResolver && (
                <button
                  onClick={() => setEstaResolviendo(true)}
                  className="w-full py-2 bg-slate-800 text-white text-xs font-black uppercase tracking-widest rounded-lg hover:bg-black transition-colors flex items-center justify-center gap-2"
                >
                  <CheckCircle size={14} />
                  Resolver y Cerrar Caso
                </button>
              )
            ) : (
              <div className="animate-in slide-in-from-top-2 duration-300">
                <div className="flex items-center gap-2 mb-2 text-slate-700">
                  <MessageSquare size={14} />
                  <span className="text-[10px] font-black uppercase">Comentario de resolución final:</span>
                </div>
                
                <textarea
                  value={comentario}
                  onChange={(e) => setComentario(e.target.value)}
                  placeholder="Escribe la solución técnica o el motivo del cierre..."
                  className="w-full p-3 text-sm border-2 border-slate-200 rounded-xl focus:border-slate-400 outline-none min-h-[80px] bg-white bg-opacity-50"
                />

                <div className="flex gap-2 mt-3">
                  <button
                    onClick={handleConfirmarResolucion}
                    className="flex-1 py-2.5 bg-green-600 text-white text-[10px] font-black uppercase rounded-lg hover:bg-green-700 flex items-center justify-center gap-2 shadow-sm"
                  >
                    <Send size={14} />
                    Confirmar Resolución
                  </button>
                  <button
                    onClick={() => { setEstaResolviendo(false); setComentario(''); }}
                    className="px-4 py-2.5 bg-white text-slate-500 text-[10px] font-black uppercase rounded-lg border border-slate-200 hover:bg-slate-50"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

      </div>
    );

  };

  //actualizar estado de revisioon
  const handleSaveRevision = async(revisionActualizada) => {

    await updateServicio(servicio.codigo,servicio.nombreEmpresa,'revision',revisionActualizada,'field');

  }

  //nuevo mensaje
  const handleNuevoMensaje = async(nuevoMensaje) => {
      if (estaEditando) {
          return toast.warning("Debes guardar o cancelar la edición antes de enviar un nuevo mensaje.");
      }
      await updateServicio(servicio.codigo, servicio.nombreEmpresa, 'chatRevision', nuevoMensaje, 'array_insert');
  };
  
  return (
    <div className="max-w-5xl mx-auto my-10 p-10 bg-white shadow-2xl rounded-3xl border border-gray-100">
      
      {/* Encabezado de Estado (Invocado arriba) */}
      {EstadoRevisionServicio()}
      
      {!revision.activo && (
          <div className="mb-12">
            <h2 className="text-4xl font-extrabold text-gray-900 tracking-tight">Iniciar Proceso de Calidad</h2>
        <p className="text-xl text-gray-500 mt-2">Completa los criterios técnicos para auditar este servicio.</p>
            <form onSubmit={handleSubmit} className="space-y-10">
          
            {/* Campo de Motivo con Select Grande */}
            <div className="space-y-3">
              <label className="text-lg font-bold text-gray-800 ml-1">
                ¿Cuál es el motivo de la revisión?
              </label>
              <Select
                name="motivo"
                value={getOptionFromValue(conceptoRevisionOptions, formData.motivo)}
                onChange={handleSelectChange}
                options={conceptoRevisionOptions}
                placeholder="Selecciona el motivo técnico..."
                isClearable
                isSearchable
                classNamePrefix="react-select"
                required
                // Aplicando estilos grandes al select vía classNamePrefix o inline styles si es necesario
                styles={{
                  control: (base) => ({
                    ...base,
                    padding: '8px',
                    borderRadius: '12px',
                    fontSize: '1.125rem'
                  })
                }}
              />
            </div>

            {/* Área de Concepto Expandida */}
            <div className="space-y-3">
              <label className="text-lg font-bold text-gray-800 ml-1">
                Concepto detallado de la Revisión
              </label>
              <textarea
                name="concepto"
                rows="6"
                value={formData.concepto}
                onChange={handleChange}
                placeholder="Describe minuciosamente el estado actual y las correcciones necesarias..."
                className="w-full p-5 text-lg border-2 border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-100 focus:border-blue-600 outline-none transition-all resize-none shadow-sm"
              ></textarea>
            </div>

          
            <div className="flex justify-end pt-6">
              <button
                type="submit"
                className="w-full md:w-auto px-12 py-5 bg-blue-600 text-white text-xl font-black rounded-2xl hover:bg-blue-700 hover:shadow-2xl hover:shadow-blue-200 active:scale-95 transition-all flex items-center justify-center gap-3"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M9 5l7 7-7 7" />
                </svg>
                REGISTRAR REVISIÓN AHORA
              </button>
            </div>

            </form>
          </div>
      )}

      {chatHabilitado && (
        <ListaChat
          mensajes={servicio.chatRevision}
          onEnviarMensaje={handleNuevoMensaje}
          codigo={servicio.codigo}
          isAdmin={isAdmin}
          resuelto={servicio.revision.resuelto}
        />
      )}

    </div>
  );

}

export default ModuloRevision
